import { Link } from 'react-router-dom';
import { EVENT } from '../data/eventInfo';
import RegisterCTA from '../components/RegisterCTA';

export default function OurMission() {
  return (
    <>
      <section className="page-hero">
        <div className="container narrow">
          <p className="page-hero-eyebrow">Our Mission</p>
          <h1>
            <span className="nowrap">The Mission is a</span>{' '}
            <span className="nowrap">Redemptive Marriage</span>
          </h1>
          <p className="page-hero-sub">
            Two people walking with God together.
          </p>
        </div>
      </section>

      <section className="section story-body">
        <div className="container narrow">
          <div className="story-block">
            <p>
              Your marriage is valuable and worth fighting for. You don't have to
              look very far to find a marriage that is in trouble. Assaults on marriage
              and challenges to marriage are everywhere. But we know there is a way for
              couples to make a comeback and actually thrive in the midst of the
              day-to-day challenges of life.
            </p>
            <p>
              Marriage is worth fighting for — and having the right tools,
              training, and orientation is crucial.
            </p>
          </div>

          <div className="story-block">
            <h3>Partnering with Zoweh Ministries</h3>
            <p>
              West Coast Marriage Camp is honored to utilize <strong>The Rendezvous Project</strong>,
              a 12-session video series from <a href="https://zoweh.org" target="_blank" rel="noopener noreferrer">Zoweh Ministries</a>,
              recorded live during one of their Rendezvous Weekend marriage conferences.
              Alongside the video series, a live experienced guide team walks with you —
              sharing their authentic and vulnerable experiences as you journey through the weekend.
            </p>
          </div>

          <div className="story-block">
            <h3>What We Explore Together</h3>
            <ul className="story-list">
              <li><strong>The Beauty of Marriage in the Kingdom</strong> — why marriage is valuable to God and the adventure He is inviting you into together.</li>
              <li><strong>Orientation</strong> — where your marriage is located in the spiritual realm, and everything set against it.</li>
              <li><strong>True Intimacy</strong> — knowing and being known, by God and by your spouse.</li>
              <li><strong>The Heart of a Woman</strong> — the beauty and design God intended when He created her.</li>
              <li><strong>The Heart of a Man</strong> — his core desires and the magnificent way that he reflects God's image.</li>
              <li><strong>True Self/False Self</strong> — who we are, and more importantly, who we are not.</li>
              <li><strong>Restoration</strong> — why our wounds matter, and how Jesus can heal them.</li>
              <li><strong>Glory</strong> — the unique calling God has for each of us.</li>
            </ul>
          </div>

          <div className="story-block closing">
            <p className="closing-line">
              Discover how a <strong>redemptive marriage</strong> ushers God's love and His Kingdom
              into our home, our relationships, and the world around us.
            </p>
          </div>
        </div>
      </section>

      <section className="section register">
        <div className="container">
          <h2>Come Walk This With Us</h2>
          <p className="subtitle">{EVENT.dateDisplay} · {EVENT.location}</p>
          <RegisterCTA className="cta-button" />
          <div style={{ marginTop: '1.5rem' }}>
            <Link to="/" className="text-link">← Back to home</Link>
          </div>
        </div>
      </section>
    </>
  );
}
